export default __webpack_public_path__ + "static/gamerize-3-c-7429a77b376ca4f1cfa1d2e803a048b5.webp";